import React, { createContext, useContext } from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";

export const Step2SidebarValue : React.FC = () => {

    let {
        dictionary,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading
    } = useZooPassAppAnswersContext();
    
    if(!answersLoading && !loading && dictionary !== null && answersData !== null)
    {
        if(answersData.step2Value === 0){
            return (<span>{dictionary.get("ZooPass:ProgressValue:02:false")}</span>)
        }
        if(answersData.step2Value === 1){
            return (<span>{dictionary.get("ZooPass:ProgressValue:02:true")} ({answersData.step2RenewalPassId ?? dictionary.get("ZooPass:ProgressValue:02:IdNotSelected")})</span>)
        }
    }
    
    return(<><span>&nbsp;</span></>);
};

